<template>
	<div>
	<div class="usertop">
		<div class="userinfo">
			<div class="avatar"><img src="/img/def_avatar.png"></div>
			<div class="infotext">
				<div class="infoname">{{nickname}}</div>
				<div class="infophone" @click="showqrcode">{{phonemask(mobilephone)}} <van-icon name="qr" size="20"/></div>
			</div>
			<div class="unlock">
				<div class="unlockbtn" @click="wxunlock"><svg-icon icon-class="unlock" style="position: absolute;top:0.3125rem;left:0.625rem;" />解除绑定</div>
			</div>
		</div>
		<div class="usermenu">
			<div @click="route2('course_list')"><van-icon name="video-o" size="40" /> <br/>我的课程</div>
			<div @click="showcalendarpop"><van-icon name="sign" size="40" /><br/>每日签到</div>
			<div @click="route2('coupon_list')"><van-icon name="coupon-o" size="40" /><br/>我的卡券</div>
			<div @click="route2('order_list')"><van-icon name="orders-o" size="40" /><br/>我的订单</div>
		</div>
	</div>
	<ul class="menulist">
		<li @click="route2('privilege')"><van-icon name="gem-o" size="40" /><div :style="{width:menuwidth}">会员特权<van-icon name="arrow" size="20" color='#999999'/></div></li>
		<li @click="route2('course_list')"><van-icon name="video-o" size="40" /><div :style="{width:menuwidth}">我的课程<van-icon name="arrow" size="20" color='#999999'/></div></li>
		<li @click="route2('jobbank')"><svg-icon icon-class="position" style="font-size: 40px;margin-top:0.625rem;"  /><div :style="{width:menuwidth}">职位查询<van-icon name="arrow" size="20" color='#999999'/></div></li>
	</ul>
	<van-calendar v-model="showcalendar" title="每日签到" @confirm="onConfirm" confirm-text="签到" :min-date="nowDate" :max-date="nowDate" :formatter="formatter"/>
	<van-popup v-model="showqr" @opened="qrcode(mobilephone)">
		<div ref="qrCodeUrl" style="padding: 0.625rem;background-color: white;"></div>
	</van-popup>
<Tabbar></Tabbar>
	</div>
</template>

<script>
	import {api_user} from '@/common/Request.js';
	import Tabbar from '@/components/tabbar.vue';
	import QRCode from 'qrcodejs2';  // 引入qrcode
	import { Dialog } from 'vant';
	import { Toast } from 'vant';
	export default {
	  data() {
	    return {
			show:false,
			menuwidth: "calc(" + window.innerWidth + "px" + " - 5rem)",
			nickname:'华智学员',
			mobilephone:'',
			userinfo:'',
			usertoken:'',
			showqr:false,
			nowDate:new Date(),
			showcalendar:false,
			checkdate:[]
	    };
	  },
	  components: {
	    Tabbar
	  },
	  mounted (){
	  	console.log(this.$cookies.get("user_token"));
	  	if(this.$cookies.isKey("user_token"))
	  	{
	  
	  		this.usertoken=this.$cookies.get("user_token");
	  		//this.nickname=this.$cookies.get("wx_nickname");
	  		this.loaduserinfo();
	  	}
	  	//this.qrcode();
	  },
	  methods:{
		  route2(routepath)
		  {
			  this.$router.push({
			    path: routepath
			  });
		  },
		  wxunlock(){
			  Dialog.confirm({
			    title: '注意',
			    message: '将解除微信账号与华智网校的绑定！',
			  })
			    .then(() => {
			      // on confirm
				  api_user.wxunlock().then(response => {
				  console.log(response.data);
				  if(response.code==0)
				  {
				  	//Toast.success(response.msg);
					Toast.success('账号解绑成功，将返回验证页面！');
				  	this.$cookies.remove("user_token");
				  	this.$router.push('/auth_new');
				  }
				  
				  });
				  
			    })
			    .catch(() => {
			      // on cancel
				  Toast('操作已取消！')
			    });
		  },
		  phonemask(phonenumber)
		  {
		  	var mystr=new String(phonenumber);
		  	var res=mystr.substr(0,3)+'****'+mystr.substr(7,mystr.split('').length);
		  	return res;
		  },
		  loaduserinfo()
		  {
			  this.mobilephone=this.$cookies.get("mobilephone");
		  },
		  qrcode(telphone){
			  this.$refs.qrCodeUrl.innerHTML="";
				 let qrcode = new QRCode(this.$refs.qrCodeUrl, {
				width: 132,
				height: 132,
				text: telphone, // 二维码地址
				colorDark : "#000",
				colorLight : "#fff",
			  });
		  },
		  showqrcode()
		  {
			  this.showqr=true;
		  },
		  onConfirm(date) {
		    api_user.usersignin().then(res=>{
		        if(res.code==0)
		        {
		          Toast.success("签到成功");
		        }
		        else
		        {
		          Toast.fail("请勿重复签到");
		        }
		    });
		  },
		  formatter(day) {
		    var cdate;
		    for( cdate in this.checkdate)
		    {
		      console.log(day.date.getTime());
		      console.log(this.checkdate[cdate]);
		      if(day.date.getTime()==this.checkdate[cdate].signintime)
		      {
		        day.bottomInfo ="已签到";
		        //day.type="disabled";
		        day.className="signined";
		      }
		    }
		  
		    return day;
		  },
		  showcalendarpop(){
		    api_user.usersignin_list().then(res=>{
		      console.log(res.data);
		      if(res.code==0){
		        this.checkdate=res.data;
		        this.showcalendar=true;
		      }
		    });
		  }
	  }
	}
</script>

<style>
  .signined{
    background-color:#ee0a24 !important;
    color: white !important;
  }
</style>

<style lang="scss" scoped>
	.usertop{
		height: 9.375rem;
		background-color: #fc4850;
		position: relative;
		.userinfo{
			height: 6.25rem;
			margin: 0 1.25rem 0 1.25rem;
			padding-top: 1.25rem;
			display: flex;
			.avatar{
				flex-grow: 0;
				flex-shrink: 0;
				flex-basis: 5rem;
				img{
					border-radius:50%;
					width:5rem;
					box-shadow: 0px 3px 8px 0px rgba(0,0,0,0.12);
					background-color: #dddddd;
				}
			}
			.infotext{
				flex-grow:1;
				flex-shrink: 1;
				flex-basis:auto;
				padding-left: 0.625rem;
				color: white;
				font-size: 1.125rem;
				padding-top: 0.625rem;
				.infoname{
					overflow: hidden;
					width: 8.75rem;
					height: 1.5rem;
				}
				.infophone{
					padding-top:0.625rem;
				}
			}
			.unlock{
				position: absolute;
				right: 1.25rem;
				top: 1.875rem;
				width: 6.25rem;
				.unlockbtn{
					position:relative;
					border-radius: 1.25rem;
					background-color: white;
					box-shadow: 0 2px 4px rgba(100,100,100,0.5);
					padding-left:1.875rem;
					height: 1.5rem;
					line-height: 1.5rem;
					font-size: 0.875rem;
				}
			}
		}
		.usermenu{
			margin: 0 1.25rem 0 1.25rem;
			background-color: white;
			height: 6.25rem;
			box-shadow: 0px 2px 4px rgba(100,100,100,0.5);
			border-radius: 0.625rem;
			display:flex;
			flex-direction: row;
			div{
				flex: 0 0 25%;
				text-align: center;
				padding-top: 1.25rem;
				font-size: 0.875rem;
			}
		}
	}
	.menulist{
		clear: both;
		margin:5rem 1.25rem 0 1.25rem;
		li{
			height: 3.75rem;
			line-height: 2.5rem;
			vertical-align: middle;
			position:relative;
			i{
				margin-top:0.625rem;
			}
			div{
				position: absolute;
				top:0.625rem;
				left: 3.75rem;
				height: 3.125rem;
				border-bottom: solid 1px #eaeaea;
				i{
					position: absolute;
					right:1.875rem;
				}
			}
		}
	}
</style>
